
import aboutNetworkingImg from '@/assets/about-networking.png';

export default function About() {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 
              className="text-3xl md:text-4xl font-bold text-gray-900 mb-6"
              style={{ fontFamily: 'Georgia, serif' }}
            >
              About Our Community
            </h2>
            
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Cambridge JBS Alumni Türkiye Society brings together graduates from across the University of Cambridge to foster meaningful connections, 
              share knowledge, and create positive impact in Türkiye and beyond. Our vibrant community spans diverse industries, 
              backgrounds, and graduation years, united by our shared Cambridge experience.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-teal-600 rounded-full mt-3 flex-shrink-0"></div>
                <p className="text-gray-700 font-medium">Community &amp; Networking</p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-teal-600 rounded-full mt-3 flex-shrink-0"></div>
                <p className="text-gray-700 font-medium">Mentorship &amp; Careers</p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-teal-600 rounded-full mt-3 flex-shrink-0"></div>
                <p className="text-gray-700 font-medium">Learning &amp; Thought Leadership</p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-teal-600 rounded-full mt-3 flex-shrink-0"></div>
                <p className="text-gray-700 font-medium">Social Impact &amp; Volunteering</p>
              </div>
            </div>
            
            <p className="text-sm text-gray-600 mt-8 italic">
              Independent alumni community led by graduates; not an official University website.
            </p>
          </div>
          
          <div className="relative">
            <img
              src={aboutNetworkingImg}
              alt="Cambridge alumni networking event"
              className="rounded-lg shadow-lg object-cover w-full h-96"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
